import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { returnDatePurchaseHistoryText } from '../../../utils/order-history/card-utils';
var ReturnDate = function (_a) {
    var fg = _a.fg, _b = _a.bold, bold = _b === void 0 ? true : _b;
    return (React.createElement("div", { className: "sui-flex sui-flex-col" },
        React.createElement(Typography, { variant: "body-base", weight: "".concat(bold ? 'bold' : 'regular') }, returnDatePurchaseHistoryText(fg))));
};
export default ReturnDate;
